var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"party-building-page"},[_vm._m(0),_c('div',{staticClass:"list-box"},[_c('news-list')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mytab"},[_c('div',{staticClass:"tag"},[_vm._v("党建动态")])])
}]

export { render, staticRenderFns }